<!-- 产品标签 是否确定无需贴标签弹框 -->
<template>
  <el-dialog 
    append-to-body
    top="25vh"
    width="600px" 
    title="是否确定无需贴标签" 
    class="review-file-dialog"
    :close-on-click-modal="false" 
    :lock-scroll="false"
    :show-close="false"
    :visible="isShow"
    @close="handleClose"
  >
    <div class="review-file-dialog__content">
      因您选择是无需标签，我们出货时板子包装上将会不进行贴标签，为尽量规避因无标签影响找板子，建议您选择需要标签。
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleEmit(2)">
        无需标签
      </el-button>
      <el-button type="primary" @click="handleEmit(0)">
        需要标签
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    open() {
      this.isShow = true
    },
    handleClose() {
      this.isShow = false
    },
    handleEmit(val) {
      this.$emit('change', val)
      this.handleClose()
    }
  },
}
</script>

<style lang="scss" scoped>
.review-file-dialog ::v-deep {
  .el-dialog__headerbtn:focus .el-dialog__close, 
  .el-dialog__headerbtn:hover .el-dialog__close {
    color: $--form-color-base;
  }
  .el-dialog__body {
    padding: 10px 20px 20px;
    line-height: 24px;
  }

  .el-dialog__footer .el-button {
    &.el-button--primary {
      border-color: $--color-primary;
      background-color: $--color-primary;
    }
    &.el-button--default {
      &:hover {
        color: $--form-color-base;
        border-color: $--form-color-base;
        background-color: $--input-background-color;
      }
    }
  }
}
</style>